import React from "react";
import LegalLayout from "components/LegalLayout";
import { LEGAL } from "components/LegalLayout/legalMeta";

// Terms of Service — SERVICE TERMS ONLY. The Privacy Policy lives on a
// separate page (/privacy); TikTok Login-Kit review requires the two to
// be distinct pages and distinct links.

const Terms = () => (
  <LegalLayout title={LEGAL.terms.title} other={LEGAL.terms.other}>
    <p>
      These Terms of Service (“Terms”) govern your use of the Prigmar AI
      business management platform at app.prigmar.com (the “Service”), operated
      by Prigmar (“we”, “us”). By creating an account or using the Service you
      agree to these Terms.
    </p>

    <h2>1. The Service</h2>
    <p>
      Prigmar provides AI-assisted tools to create, schedule, and publish
      content and to manage marketing across connected channels, including
      social media, email, SEO, chat, and CRM.
    </p>

    <h2>2. Accounts &amp; Registration</h2>
    <p>
      You must provide accurate registration information and are responsible for
      safeguarding your credentials and for all activity under your account. You
      must be at least 18 years old and authorized to act for any business you
      represent.
    </p>

    <h2>3. Acceptable Use</h2>
    <p>You agree not to use the Service to:</p>
    <ul>
      <li>violate any law or the terms or policies of any connected platform;</li>
      <li>post unlawful, infringing, deceptive, or harmful content;</li>
      <li>send spam or unsolicited messages, or impersonate others;</li>
      <li>attempt to disrupt, reverse-engineer, or gain unauthorized access to the Service.</li>
    </ul>

    <h2>4. Connected Social Accounts</h2>
    <p>
      The Service lets you connect third-party platforms (such as TikTok,
      Facebook, Instagram, LinkedIn, and X) to publish content on your behalf.
      Your use of each platform remains subject to that platform’s own terms and
      policies, and you are responsible for complying with them. We act only on
      the actions you authorize and you may disconnect any account at any time.
    </p>

    <h2>5. Subscriptions, Billing &amp; Refunds</h2>
    <p>
      Paid plans are billed in advance on a recurring basis until cancelled. You
      may cancel at any time, effective at the end of the current billing
      period. Refund requests may be submitted within 7 days of a charge;
      pro-rated refunds may be available for unused service periods. Custom
      development work and partial months are non-refundable.
    </p>

    <h2>6. Intellectual Property</h2>
    <p>
      The Service, including its software and branding, is owned by Prigmar. You
      retain ownership of the content you create, and you grant us the limited
      rights needed to host and publish it to the channels you connect.
    </p>

    <h2>7. Your Content &amp; Responsibility</h2>
    <p>
      You are responsible for the content you create and publish through the
      Service and for ensuring you have the rights to use it. AI-generated
      output should be reviewed before publishing.
    </p>

    <h2>8. Termination</h2>
    <p>
      You may stop using the Service at any time. We may suspend or terminate
      access for violation of these Terms or to protect the Service and its
      users.
    </p>

    <h2>9. Disclaimers</h2>
    <p>
      The Service is provided “as is” without warranties of any kind. We do not
      guarantee uninterrupted or error-free operation, or any particular
      marketing result.
    </p>

    <h2>10. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, Prigmar is not liable for
      indirect, incidental, or consequential damages, and our total liability is
      limited to the amount you paid for the Service in the 12 months before the
      claim.
    </p>

    <h2>11. Changes to These Terms</h2>
    <p>We may update these Terms and will revise the “Last updated” date above. Continued use after changes constitutes acceptance.</p>

    <h2>12. Governing Law</h2>
    <p>These Terms are governed by the laws of the State of Arizona, USA, without regard to conflict-of-law rules.</p>

    <h2>13. Contact</h2>
    <p>
      Prigmar<br />
      <a href="mailto:support@prigmar.com">support@prigmar.com</a><br />
      +1 928 478 1277<br />
      64 E Broadway Rd, Suite 200, Tempe, AZ, USA
    </p>
  </LegalLayout>
);

export default Terms;
